<template>
  <div class="row justify-content-center justify-content-xl-between">
    <div class="col-12 border-bottom" v-if="TrayData.length > 0">
      <div
        class="row justify-content-between align-content-center align-items-center py-3"
      >
        <div class="col-6 p-0 col-xl-4">
          <span class="medium board-name-font my-tray-list-title">
            {{ $resourceString["myProject.Project.Project.Title"] }}
          </span>
        </div>
        <div class="col-2 p-0 text-center">
          <a @click="handleSorting">
            <span
              class="png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1 bg-transparent mr-0"
              :style="transform ? 'transform: rotate(180deg)' : ''"
            ></span>
            <button
              type="button"
              class="btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize"
              data-sort-type="ProductsCount"
              :data-ascending="isAscending.toString()"
            >
              {{ $resourceString["account.Tray.Product.Title"] }}
            </button>
          </a>
        </div>
        <div class="col-2 p-0  d-lg-block text-right">
          <a @click="handleSorting">
            <span
              class="png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1 mr-0 bg-transparent"
              :style="transform ? 'transform: rotate(180deg)' : ''"
            ></span>
            <button
              type="button"
              class="btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize"
              data-sort-type="UpdatedAt"
              :data-ascending="isAscending.toString()"
            >
              {{ $resourceString["common.accounts.Title.UpdatedOn"] }}
            </button>
          </a>
        </div>
        <div class="col-2 p-0  d-lg-block text-right">
          <a @click="handleSorting">
            <span
              class="png-icon bg-light position-relative png-icon-icons-glyph--g-more mb-1  mr-0 bg-transparent"
              :style="transform ? 'transform: rotate(180deg)' : ''"
            ></span>
            <button
              type="button"
              class="btn medium btn-sort text-size-normal p-0 tabe-data-font text-capitalize"
              data-sort-type="CreatedAt"
              :data-ascending="isAscending.toString()"
            >
              {{ $resourceString["common.accounts.Title.CreatedOn"] }}
            </button>
          </a>
        </div>
      </div>
    </div>
    <div
      class="board-card list col-12 border-bottom box-shadow-hover-3 list-view-hover tabe-data-font "
      v-if="TrayData.length > 0"
      v-for="card in selectedTab === brand ? TrayItems : TrayData"
      :key="card.title"
    >
      <div
        class="row justify-content-between align-content-center align-items-center py-3 h-100"
      >
        <div class="col-6 col-xl-4">
          <div class="d-flex no-gutters align-items-center">
            <picture
              class="img-comp img-wrapper d-inline-block img-width-list-view"
            
            >
              <img
              v-if="card.coverPhoto"
                class="h-100 img-list-view-mobile"
                :alt="card.title"
                data-object-fit="true"
                :src="card.coverPhoto || ''"
              />
            </picture>

            <div class="mx-5 font-16 tray-name-marginn-in-mobile">
              <a
                class="card-title text-size-normal stretched-link black text-dark project-title"
                :href="`/Project/Edit/${card.id}`"
                ref="dynamicEditLink"
              >
                {{ card.title }}
              </a>
            </div>

            <div class="top-right-menu_controls dark hidden-img-div">
              <div class="top-right-menu_controls_container">
                <div class="show dropdown">
              <div class="btn-group dropleft" role="group">
                <button
                  type="button"
                  class="btn dropdown-toggle-split p-0"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="selectedTab.toLowerCase() != 'shared'"
                >
                  <span class="sr-only"></span>
                  <img
                    style="width: 5px"
                    src="https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg"
                    alt=""
                  />
                </button>

                <div
                  class="dropdown-menu bg-white"
                  aria-labelledby="dropdownMenuLink"
                >
                  <a
                    class="dropdown-item font-16"
                    :href="`/Project/Edit/${card.id}`"
                    ref="dynamicEditLink"
                  >
                    {{ $resourceString["myProject.Project.EditProject.Title"] }}
                  </a>
                  <a
                    href=""
                    v-if="
                      selectedTab === archived || selectedTab === active
                    "
                    class="dropdown-item font-16"
                    @click.prevent="handleArchiveTray(card.id)"
                  >
                    {{
                      selectedTab === archived
                        ? $resourceString[
                            "myProject.Project.ReactivateProject.Title"
                          ]
                        : $resourceString[
                            "myProject.Project.ArchivedProject.Title"
                          ]
                    }}
                  </a>

                  <a
                    class="dropdown-item font-16"
                    href=""
                    v-if="
                      selectedTab === brand &&
                        card.brandBoardStatus === 0 &&
                        isAdminMode
                    "
                    @click.prevent="publishTray(card.id)"
                  >
                    {{
                      $resourceString[
                        "myProject.Project.Option.Publish.Project"
                      ]
                    }}
                  </a>
                  <a
                    class="dropdown-item font-16"
                    href=""
                    v-if="
                      selectedTab === brand &&
                        card.brandBoardStatus === 2 &&
                        isAdminMode
                    "
                    @click.prevent="unpublishTray(card.id)"
                  >
                    {{
                      $resourceString[
                        "myProject.Project.Option.Unpublish.Project"
                      ]
                    }}
                  </a>
                  <div class="dropdown-divider"></div>
                  <a
                    href=""
                    v-if="
                      isAdminMode ||
                        selectedTab === archived||
                        selectedTab === active
                    "
                    class="dropdown-item font-danger font-16"
                    @click.prevent="handleDeleteTray(card.id)"
                  >
                    {{
                      $resourceString["myProject.Project.DeleteProject.Title"]
                    }}
                  </a>
                </div>
              </div>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-2 col-xl-2 black text-center">
          {{ getItems(card, [isProduct, isPaint]).length }}
        </div>
        <div class="col-2 font-16  d-lg-block text-right">
          {{
            new Date(card.updatedAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric"
            })
          }}
        </div>
        <div class="col-2 font-16  d-lg-block text-right">
          {{
            new Date(card.createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric"
            })
          }}
        </div>
      </div>
    </div>
    <div v-if="TrayData.length == 0 && !showLoadMore" class="text-center mt-4">
      <p>{{ $resourceString["common.NoDataAvailable.Msg"] }}</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["isAdminMode"],
  data() {
    return {
      editTrayId: "",
      productResult: [],
      isAscending: true,
      sortElement: null,
      ContentItemTypes: {
        product: "product",
        paint: "paint"
      },
      transform: false,
      brand: this.$resourceString['common.accounts.Label.Brand'],
      archived: this.$resourceString['common.accounts.Label.Archived'],
      active: this.$resourceString['common.accounts.Label.Active'],
      function: this.$resourceString['common.accounts.Label.Function'],
      asc: this.$resourceString['common.accounts.Label.Asc'],
      desc: this.$resourceString['common.accounts.Label.Desc'],
    };
  },

  computed: {
    ...mapGetters({
      TrayData: "myTray/getAllVirtualTrayBoardData",
      selectedTab: "myTray/getselectedTabName",
      showLoadMore: "myTray/showLoadMore",
      getVirtualTrayParamSortBy: "myTray/getVirtualTrayParamSortBy"
    }),

    TrayItems() {
      if (!this.isAdminMode) {
        return this.TrayData.filter(card => card.brandBoardStatus !== 0);
      } else {
        return this.TrayData;
      }
    }
  },

  methods: {
    ...mapActions({
      clearSelectedTrayIdAfterApiCall: "myTray/clearSelectedTrayIdAfterApiCall",
      deleteVirtualTray: "myTray/deleteVirtualTray",
      archiveVirtualTray: "myTray/archiveVirtualTray",
      updateSelectedTrayId: "myTray/updateSelectedTrayId",
      getUserTrayIdApiDetails: "myTray/getUserTrayIdApiDetails",
      updateShareTrayIfFromMyTrayPage: "myTray/updateShareTrayIfFromMyTrayPage",
      upadteOrderby: "myTray/upadteOrderby",
      upadteSelectedSortby: "myTray/upadteSelectedSortby",
      modalArchiveMsg: "myTray/modalArchiveMsg",
      publishTrayApi: "myTray/publishTrayApi",
      unpublishTrayApi: "myTray/unpublishTrayApi",
      virtualTrayEdit: "myTray/virtualTrayEdit",
      updateAllVirtualTray: "myTray/updateAllVirtualTray",
      resourceString: "myTray/resourceString"
    }),

    async publishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(this.$resourceString["common.Published.Msg"]);
      await this.publishTrayApi(data);
    },

    async unpublishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(this.$resourceString["common.Unpublished.Msg"]);
      await this.unpublishTrayApi(data);
    },

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    shareTray(id) {
      this.updateShareTrayIfFromMyTrayPage(id);
      this.showModal("share-tray");
      let data = {
        boardId: id ? id : "",
        isAdmin: this.isAdminMode ? this.isAdminMode : false
      };
      this.getUserTrayIdApiDetails(data);
    },

    async handleArchiveTray(id) {
      await this.modalArchiveMsg(this.$resourceString["common.accounts.Label.Reactivate"]);
      await this.resourceString(
        this.selectedTab === this.archived
          ? this.$resourceString["common.accounts.Reactivate.Msg"]
          : this.$resourceString["common.accounts.Archived.Msg"]
      );
      await this.archiveVirtualTray(id);
      await this.updateAllVirtualTray('ProjectFeature');
    },

    async handleDeleteTray(id) {
      await this.resourceString(
        this.$resourceString["common.accounts.Deleted.Msg"]
      );
      await this.deleteVirtualTray(id);
      await this.updateAllVirtualTray('ProjectFeature');
    },

    isProduct(type) {
      return this.ContentItemTypes.product === type;
    },

    isPaint(type) {
      return this.ContentItemTypes.paint === type;
    },

    getItems(boards = [], arg2 = []) {
      let elements = [];
      boards.sections.forEach(el => {
        el.contentItems.forEach(elem => {
          elements.push(elem);
        });
      });

      if (typeof arg2 === this.function) {
        elements.filter(item => arg2(item.type));
      } else if (arg2.length) {
        elements.filter(function(item) {
          return arg2.some(function(isType) {
            return isType(item.type);
          });
        });
      }
      return elements;
    },

    handleSorting(e) {
      const target = e.currentTarget;
      if (this.sortElement === target) {
        this.isAscending = !this.isAscending;
      } else {
        this.isAscending = true;
      }

      this.sortElement = target;

      const orderType = this.isAscending ? this.asc : this.desc;
      this.upadteOrderby(orderType);
      this.upadteSelectedSortby(this.getVirtualTrayParamSortBy);
      this.transform = !this.transform;
    }
  }
};
</script>
